import produce from 'immer';

import {
  CASE_INSPECTION_ASSIGNEES_FAILURE,
  CASE_INSPECTION_ASSIGNEES_SUCCESS,
  CREATE_DELEGATE_WORK_FAILURE,
  CREATE_DELEGATE_WORK_SUCCESS,
  DELETE_USER_SIGNATURE_IMAGE_FAILURE,
  DELETE_USER_SIGNATURE_IMAGE_SUCCESS,
  EDIT_USER_SIGNATURE_FAILURE,
  EDIT_USER_SIGNATURE_IMAGE_FAILURE,
  EDIT_USER_SIGNATURE_IMAGE_SUCCESS,
  EDIT_USER_SIGNATURE_SUCCESS,
  FETCH_DELEGATE_WORK_FAILURE,
  FETCH_DELEGATE_WORK_SUCCESS,
  FETCH_RECENT_ASSIGNEE_FAILURE,
  FETCH_RECENT_ASSIGNEE_SUCCESS,
  FETCH_STAFF_TEXT_PROFILE_SUCCESS,
  FETCH_USER_PREFERENCES_FAILURE,
  FETCH_USER_PREFERENCES_SUCCESS,
  GET_CE_ADMIN_USERS_FAILURE,
  GET_CE_ADMIN_USERS_SUCCESS,
  GET_CRM_ADMIN_USERS_FAILURE,
  GET_CRM_ADMIN_USERS_SUCCESS,
  GET_CRM_ASSIGNEE_FAILURE,
  GET_CRM_ASSIGNEE_SUCCESS,
  GET_CRM_USERS_FAILURE,
  GET_CRM_USERS_SUCCESS,
  GET_XERCE_ASSIGNEES_FAILURE,
  GET_XERCE_ASSIGNEES_SUCCESS,
  INSPECTION_ASSIGNEES_FAILURE,
  INSPECTION_ASSIGNEES_SUCCESS,
  LOAD_MORE_GET_CRM_ASSIGNEE_SUCCESS,
  LOAD_MORE_GET_CRM_USERS_SUCCESS,
  LOAD_MORE_GET_XERCE_ASSIGNEES_SUCCESS,
  LOAD_MORE_INSPECTION_ASSIGNEES_SUCCESS,
  LOAD_MORE_USERS,
  RESEND_STAFF_TEXT_ENROLLMENT_SUCCESS,
  START_STAFF_TEXT_ENROLLMENT_SUCCESS,
  UPDATE_DELEGATE_WORK_FAILURE,
  UPDATE_DELEGATE_WORK_SUCCESS,
  UPDATE_USER_PREFERENCES_FAILURE,
  UPDATE_USER_PREFERENCES_FILTER_FAILURE,
  UPDATE_USER_PREFERENCES_FILTER_SUCCESS,
  UPDATE_USER_PREFERENCES_SUCCESS,
  USER_EDIT_PROFILE_SUCCESS,
  USER_FETCH_PROFILE_SUCCESS,
  USER_FETCH_SUCCESS,
  USER_FORGOT_PASSWORD_FAILURE,
  USER_SEND_VERIFICATION_EMAIL_FAILURE,
  USER_SEND_VERIFICATION_EMAIL_SUCCESS,
  USER_UPDATE_FAILURE,
  USER_UPDATE_SUCCESS,
  USERS_FETCH_SUCCESS,
} from '@actions/user';

const initialState: IUserStore = {
  currentUser: null,
  assignees: null,
  caseInspectionAssignees: null,
  ceAdminUsers: null,
  crmAdminUsers: null,
  users: null,
  error: null,
  loggedInUser: null,
  staffTextProfile: null,
  userPreferences: null,
  crmAssignees: [],
  xerceAssignees: [],
  crmUsers: [],
  delegateWorkConfig: null,
  crmUsersCount: 0,
  crmAssigneesCount: 0,
  xerceAssigneesCount: 0,
  assigneesCount: 0,
  caseInspectionAssigneesCount: 0,
  frequentInspectionAssignees: null,
  lastInspectionAssignees: null,
  frequentCaseAssignees: null,
  lastCaseAssignees: null,
};

export default (state: IUserStore = initialState, action: any) =>
  produce(state, (draftState: IUserStore) => {
    switch (action.type) {
      case USERS_FETCH_SUCCESS:
        draftState.users = action.response;
        draftState.error = null;

        return;

      case USER_FETCH_SUCCESS:
        draftState.currentUser = action.response;

        return;

      case USER_FETCH_PROFILE_SUCCESS:
      case USER_EDIT_PROFILE_SUCCESS:
        draftState.loggedInUser = action.response;

        return;

      case EDIT_USER_SIGNATURE_SUCCESS:
        draftState.loggedInUser.signature = action.response.signature;

        return;

      case EDIT_USER_SIGNATURE_IMAGE_SUCCESS:
        draftState.loggedInUser.signatureFileURL = action.response.signatureURL;

        return;

      case DELETE_USER_SIGNATURE_IMAGE_SUCCESS:
        draftState.loggedInUser.signatureFileURL = null;

        return;

      case FETCH_STAFF_TEXT_PROFILE_SUCCESS:
      case START_STAFF_TEXT_ENROLLMENT_SUCCESS:
      case RESEND_STAFF_TEXT_ENROLLMENT_SUCCESS:
        draftState.staffTextProfile = action.response;

        return;

      case USER_UPDATE_SUCCESS:
        draftState.currentUser = action.response;
        draftState.error = null;

        return;

      case USER_UPDATE_FAILURE:
        draftState.error =
          action.originalError && action.originalError.response && action.originalError.response.data.message;

        return;

      case INSPECTION_ASSIGNEES_SUCCESS:
        draftState.assignees = action.response.data;
        draftState.assigneesCount = action.response.count;
        draftState.error = null;

        return;

      case LOAD_MORE_INSPECTION_ASSIGNEES_SUCCESS:
        draftState.assignees = draftState.assignees.concat(action.response.data);
        draftState.assigneesCount = action.response.count;
        draftState.error = null;

        return;

      case CASE_INSPECTION_ASSIGNEES_SUCCESS:
        draftState.caseInspectionAssignees = action.response.data;
        draftState.caseInspectionAssigneesCount = action.response.count;
        draftState.error = null;

        return;

      case FETCH_USER_PREFERENCES_SUCCESS:
      case UPDATE_USER_PREFERENCES_SUCCESS:
      case UPDATE_USER_PREFERENCES_FILTER_SUCCESS:
        draftState.userPreferences = action.response;
        draftState.error = null;

        return;

      case GET_CRM_ASSIGNEE_SUCCESS:
        draftState.crmAssignees = action.response.data;
        draftState.crmAssigneesCount = action.response.count;
        draftState.error = null;

        return;

      case LOAD_MORE_GET_CRM_ASSIGNEE_SUCCESS:
        draftState.crmAssignees = draftState.crmAssignees.concat(action.response.data);
        draftState.crmAssigneesCount = action.response.count;
        draftState.error = null;

        return;

      case GET_CRM_USERS_SUCCESS:
        draftState.crmUsers = action.response.data;
        draftState.crmUsersCount = action.response.count;
        draftState.error = null;

        return;

      case LOAD_MORE_GET_CRM_USERS_SUCCESS:
        draftState.crmUsers = draftState.crmUsers.concat(action.response.data);
        draftState.crmUsersCount = action.response.count;
        draftState.error = null;

        return;

      case GET_XERCE_ASSIGNEES_SUCCESS:
        draftState.xerceAssignees = action.response.data;
        draftState.xerceAssigneesCount = action.response.count;
        draftState.error = null;

        return;

      case LOAD_MORE_GET_XERCE_ASSIGNEES_SUCCESS:
        draftState.xerceAssignees = draftState.xerceAssignees.concat(action.response.data);
        draftState.xerceAssigneesCount = action.response.count;
        draftState.error = null;

        return;

      case LOAD_MORE_USERS:
        const { data, count } = action.response;
        draftState.users.data = draftState.users.data.concat(data);
        draftState.users.count = count;
        draftState.error = null;

        return;

      case GET_CE_ADMIN_USERS_SUCCESS:
        draftState.ceAdminUsers = action.response.data;
        draftState.error = null;

        return;

      case GET_CRM_ADMIN_USERS_SUCCESS:
        draftState.crmAdminUsers = action.response.data;
        draftState.error = null;

        return;

      case INSPECTION_ASSIGNEES_FAILURE:
      case CASE_INSPECTION_ASSIGNEES_FAILURE:
      case USER_FORGOT_PASSWORD_FAILURE:
      case EDIT_USER_SIGNATURE_FAILURE:
      case EDIT_USER_SIGNATURE_IMAGE_FAILURE:
      case FETCH_USER_PREFERENCES_FAILURE:
      case UPDATE_USER_PREFERENCES_FAILURE:
      case UPDATE_USER_PREFERENCES_FILTER_FAILURE:
      case DELETE_USER_SIGNATURE_IMAGE_FAILURE:
      case GET_CRM_ASSIGNEE_FAILURE:
      case GET_XERCE_ASSIGNEES_FAILURE:
      case GET_CE_ADMIN_USERS_FAILURE:
      case GET_CRM_ADMIN_USERS_FAILURE:
      case GET_CRM_USERS_FAILURE:
      case FETCH_DELEGATE_WORK_FAILURE:
      case CREATE_DELEGATE_WORK_FAILURE:
      case UPDATE_DELEGATE_WORK_FAILURE:
        draftState.error = action.error;

        return;

      case FETCH_DELEGATE_WORK_SUCCESS:
      case CREATE_DELEGATE_WORK_SUCCESS:
      case UPDATE_DELEGATE_WORK_SUCCESS:
        draftState.delegateWorkConfig = action.response;

        return;

      case FETCH_RECENT_ASSIGNEE_SUCCESS:
        draftState.frequentInspectionAssignees = action.response.frequentInspectionAssignees;
        draftState.lastInspectionAssignees = action.response.lastInspectionAssignees;
        draftState.frequentCaseAssignees = action.response.frequentCaseAssignees;
        draftState.lastCaseAssignees = action.response.lastCaseAssignees;
        draftState.error = null;

        return;

      case FETCH_RECENT_ASSIGNEE_FAILURE:
        draftState.error = action.error;

        return;

      case USER_SEND_VERIFICATION_EMAIL_SUCCESS:
        draftState.error = null;

        return;

      case USER_SEND_VERIFICATION_EMAIL_FAILURE:
        draftState.error = action.originalError?.response?.data?.message || 'Failed to send verification email';

        return;
    }
  });
